export default "__VITE_PUBLIC_ASSET__5ffd7975__"